<template>
  <BaseElDialog
    title="Cambios sin guardar"
    :visible.sync="showModal"
    @open="handleOpenModalDialog('container-handleOpenModal-changes')"
    @closed="releaseFocusDialog"
    width="40%"
    :show-close="false"
    custom-class="min-width-dialog"
    center>
    <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ message }}</span>
    <template slot="footer" >
      <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-changes">
        <base-button class="w-full" @click="cancelar()" mode="secondary-phantom-blue" :text="this.$i18n.t('app.cancel')"/>
        <base-button class="w-full" @click="confirmar()" mode="secondary-phantom-blue" :text="this.$i18n.t('app.exit')"/>
      </div>
    </template>
  </BaseElDialog>
</template>

<script>
import BaseElDialog from '@/components/base/BaseElDialog.vue'

export default
{
  name: 'confirmation-changes-dialog',
  components: {
    BaseElDialog
  },
  props: {
  },
  data: function () {
    return {
      message: this.$i18n.t('app.form_changes_dialog_message'),
    }
  },
  computed: {
    showModal () {
      return this.$store.getters['app/showModalConfirmChanges'] ?? false
    },
  },
  methods: {
    confirmar () {
      // Si se confirma limpiamos cambios, cerramos dialogo y enviamos a la ultima ruta guardada
      this.$store.commit('app/setFormChanges', false)
      this.$store.commit('app/setShowModalConfirmChanges', false)
      const route = this.$store.getters['app/lastRouteComplete']
      this.$router.push(route)
    },
    cancelar () {
      // Si cancela ya esta cancelada la ruta, solo cerramos dialogo
      this.$store.commit('app/setShowModalConfirmChanges', false)
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
  },
}
</script>

<style lang="scss" scoped></style>
